/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_stx_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which seasons of data are available?`)
};

const es_f1_stx_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué temporadas de datos están disponibles?`)
};

const de_f1_stx_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für welche Saisons sind Daten verfügbar?`)
};

const nl_f1_stx_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke seizoenen met gegevens zijn beschikbaar?`)
};

const fr_f1_stx_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelles saisons de données sont disponibles ?`)
};

const it_f1_stx_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quali stagioni di dati sono disponibili?`)
};

const pt_br2_f1_stx_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais temporadas de dados estão disponíveis?`)
};

const pt_f1_stx_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que épocas de dados estão disponíveis?`)
};

const ja_f1_stx_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのシーズンのデータが利用できますか？`)
};

const zh_f1_stx_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有哪些赛季的数据可用？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_stx_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_stx_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_stx_faq3_q", locale)
	if (locale === "en") return en_f1_stx_faq3_q(inputs)
	if (locale === "es") return es_f1_stx_faq3_q(inputs)
	if (locale === "de") return de_f1_stx_faq3_q(inputs)
	if (locale === "nl") return nl_f1_stx_faq3_q(inputs)
	if (locale === "fr") return fr_f1_stx_faq3_q(inputs)
	if (locale === "it") return it_f1_stx_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_stx_faq3_q(inputs)
	if (locale === "pt") return pt_f1_stx_faq3_q(inputs)
	if (locale === "ja") return ja_f1_stx_faq3_q(inputs)
	return zh_f1_stx_faq3_q(inputs)
};